import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { delay } from 'rxjs/operators';

import { BaseUI } from '../../base.ui';
import { Country, ShareHolder } from '../../../domain/data';
import { ErrorDialog } from '../../dialog/error/error.dialog';
import { GetCountriesUseCase, Nature } from '../../../../core';
import { ParentEvents } from '../../../utils/parent-events.service';

@Component({
    selector: 'thr-full-data-shareholder-table',
    templateUrl: './full-data-shareholder-table.component.html',
    styleUrls: ['./full-data-shareholder-table.component.scss'],
})
export class FullDataShareholderTableComponent extends BaseUI implements AfterViewInit, OnDestroy, OnInit {
    Nature: typeof Nature = Nature;

    public countries: Country[] = [];

    @Input()
    shareHolders: ShareHolder[] = [];

    @Input()
    owner = false;

    @Input()
    isDisabled = false;

    @Output()
    edit: EventEmitter<ShareHolder> = new EventEmitter();

    @Output()
    remove: EventEmitter<ShareHolder> = new EventEmitter();

    constructor(parentEvents: ParentEvents, private dialog: MatDialog, private getCountriesUseCase: GetCountriesUseCase) {
        super(parentEvents);
    }

    ngOnInit() {
        this.getCountries();
    }

    private getCountries() {
        this.getCountriesUseCase
            .bind()
            .pipe(delay(1)) // prevent ExpressionChangedAfterItHasBeenCheckedError
            .subscribe((transaction) => {
                if (transaction.isSuccess) {
                    this.countries = transaction.data as Country[];
                } else if (!transaction.isAuthError) {
                    this.dialog.open(ErrorDialog);
                }
            });
    }

    onEdit(shareHolder: ShareHolder) {
        this.edit.next(shareHolder);
    }

    onRemove(shareHolder: ShareHolder) {
        this.remove.next(shareHolder);
    }
}
